import { FC } from 'react';
import { useFragment } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';
import format from 'date-fns/format';

import TableRow from '@mui/material/TableRow';
import Tooltip from '@mui/material/Tooltip';
import TableCell from 'components/TableCell';
import FlightPriceChangeIcon from 'components/FlightPriceChangeIcon';

import { FlightPriceHistoryRow_entry$key } from '__generated__/FlightPriceHistoryRow_entry.graphql';

type Props = {
  entry: FlightPriceHistoryRow_entry$key;
  hideNotes?: boolean;
};

const FlightPriceHistoryRow: FC<Props> = ({ hideNotes, ...props }) => {
  const entry = useFragment(
    graphql`
      fragment FlightPriceHistoryRow_entry on FlightPrice {
        priceChange
        newPrice
        actualPrice
        createdAt
        status
        serviceMessage

        ...FlightPriceChangeIcon_entry
      }
    `,
    props.entry
  );

  const {
    priceChange,
    newPrice,
    actualPrice,
    createdAt,
    status,
    serviceMessage,
  } = entry;

  const createdAtDate = new Date(createdAt);

  return (
    <TableRow>
      <TableCell>{format(createdAtDate, 'yyyy-MM-dd')}</TableCell>

      <TableCell center>{format(createdAtDate, 'HH:mm')}</TableCell>

      <TableCell center>
        <FlightPriceChangeIcon entry={entry} />
        {priceChange}%
      </TableCell>

      <TableCell center>€{newPrice}</TableCell>
      <TableCell center>€{actualPrice}</TableCell>

      {!hideNotes && (
        <TableCell center>
          {status !== 'ok' &&
            (serviceMessage ? (
              <Tooltip title={serviceMessage}>
                <span>{status}</span>
              </Tooltip>
            ) : (
              status
            ))}
        </TableCell>
      )}
    </TableRow>
  );
};

export default FlightPriceHistoryRow;
